import * as React from 'react';
import './OverlayHeader.scss';

export const OverlayHeader = ({ children }) => {
  return <h6 className='overlay-header'>{children}</h6>;
};
